"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppSelector = exports.useAppDispatch = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _reactRedux = require("react-redux");
var _rootReducer = _interopRequireDefault(require("./rootReducer"));
const store = (0, _toolkit.configureStore)({
  reducer: _rootReducer.default
});
const useAppDispatch = exports.useAppDispatch = _reactRedux.useDispatch;
const useAppSelector = exports.useAppSelector = _reactRedux.useSelector;
var _default = exports.default = store;